import { toast } from "sonner";

// Una acción = un toast. El id derivado del mensaje evita apilar/duplicar el mismo aviso.
export const notifyOk = (msg) => toast.success(msg, { id: `ok:${msg}`, duration: 3000 });
export const notifyWarn = (msg) => toast.warning(msg, { id: `warn:${msg}`, duration: 4000 });
export const notifyError = (msg) => toast.error(msg, { id: `err:${msg}`, duration: 4500 });
